module.exports = __webpack_public_path__ + "static/asg-41287e2ad9a513751d4e899afb7e38a4.png";